<template>
  <With_Header_Modal_Template title="История посещений" without-footer>
    <div class="history">
      <div class="item"
           v-for="(item, idx) in history"
           :key="idx"
      >
        <div class="item__flex">
          <div class="left">
            <div class="title">{{ item.title }}</div>
            <div class="date">{{ item.date }}</div>
          </div>
          <div class="price">{{ item.price }}</div>
          <button
              :class="['chevron', {rotated: item.isShownFullInfo}]"
              @click="item.isShownFullInfo = !item.isShownFullInfo"
          >
            <img src="../../../../assets/images/icons/chevron-down-black.svg" alt="">
          </button>
        </div>
        <div class="comment" v-if="item.isShownFullInfo">
          <input type="text" placeholder="Комментарий" v-model="item.comment">
        </div>
      </div>
    </div>
  </With_Header_Modal_Template>
</template>

<script>
import With_Header_Modal_Template from '@/components/Modals/ModalsTemplate/With_Header_Modal_Template'

export default {
  name: "HistoryModal",
  components: {With_Header_Modal_Template},
  data: () => ({
    history: [
      {
        title: 'Дневной макияж',
        date: '28 июня 2020',
        price: '2 200 Р',
        comment: '',
        isShownFullInfo: false
      },
      {
        title: 'Дневной макияж 2',
        date: '28 июня 2020',
        price: '2 200 Р',
        comment: '',
        isShownFullInfo: false
      },
      {
        title: 'Дневной макияж 3',
        date: '28 июня 2020',
        price: '2 200 Р',
        comment: '',
        isShownFullInfo: false
      },
      {
        title: 'Дневной макияж 4',
        date: '28 июня 2020',
        price: '2 200 Р',
        comment: '',
        isShownFullInfo: false
      },
    ]
  })
}
</script>

<style scoped lang="scss">
.history {
  max-height: 100%;
  overflow: auto;
}
.item {
  padding: 20px 15px;
  border-bottom: 1px solid #E5E5E5;
  &__flex {
    align-items: center;
    display: flex;
  }
  .price {
    margin-left: auto;
    margin-right: 10px;
    font-weight: 600;
    font-size: 16px;
    line-height: 1.5;
    color: #383838;
  }
  .chevron {
    border: none;
    width: 20px;
    height: 20px;
    background-color: transparent;
    &.rotated {
      transform: rotateZ(180deg);
    }
  }
  .title {
    font-size: 16px;
    line-height: 1.5;
    color: #383838;
    margin-bottom: 2px;
  }
  .date {
    font-size: 16px;
    line-height: 1.5;
    color: #808080;
  }
  .comment {
    margin-top: 20px;
    input {
      width: 100%;
      height: 40px;
      background: #FFFFFF;
      border: 1px solid #DBBFA7;
      border-radius: 5px;
      padding-left: 15px;
      &::placeholder {
        font-size: 16px;
        color: #808080;
      }
    }
  }
}
</style>
